module.exports = __webpack_public_path__ + "static/media/logowhite.8e8a61bf.png";